var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59083 4.36319V1.4541M10.409 4.36319V1.4541M3.86356 7.27228H11.1363M2.40901 14.545H12.5908C13.3942 14.545 14.0454 13.8938 14.0454 13.0905V4.36319C14.0454 3.55987 13.3942 2.90865 12.5908 2.90865H2.40901C1.60569 2.90865 0.954468 3.55987 0.954468 4.36319V13.0905C0.954468 13.8938 1.60569 14.545 2.40901 14.545Z",
    stroke: "white",
    strokeWidth: 1.09091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.545b82e239b36062c4963e2aa5f9df2c.svg";
export { ForwardRef as ReactComponent };